export const UPDATE_APP_LOADING_STATUS = 'UPDATE_APP_LOADING_STATUS'
export const UPDATE_APP_MODULE_LOADING_STATUS = 'UPDATE_APP_MODULE_LOADING_STATUS'
export const SET_APP_ASIDE_MINIMIZE_STATE = 'SET_APP_ASIDE_MINIMIZE_STATE'
